/**
 * 인증 API — Sprint 1 에서 백엔드와 동시 구현.
 */
import { http } from './http';
import type { AuthUser } from '@nojira/shared';
import type { LoginInput } from '@nojira/shared/schemas/auth';

export async function fetchMe(): Promise<AuthUser | null> {
  try {
    const res = await http.get<AuthUser>('/api/auth');
    return res.data;
  } catch {
    return null;
  }
}

export async function login(input: LoginInput): Promise<AuthUser> {
  const res = await http.post<AuthUser>('/api/login', input);
  return res.data;
}

export async function logout(): Promise<void> {
  await http.post('/api/logout');
}
